// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gi-0";
export var actionModalContentContainer = "_gi-1";